import axiosInstance from "./axiosInstance";

export function loadDashboardOverview(startingDate, endingDate) {
  return axiosInstance.get("/dashboard/overview", {
    params: { startingDate, endingDate },
  });
}
